import React from "react";
import { Container, Visible, Hidden } from "react-grid-system";
import { Link, Redirect } from "react-router-dom";
import style from "./Style.module.css";
import logo from "../../asset/logo.png";
import logonav from "../../asset/logonav.png";
import cartPic from "../../asset/cart.svg";
import bellPic from "../../asset/bell.svg";
import Util from "../../Util";

const menus = [
  { match: "home", to: "/", label: "หน้าแรก" },
  { match: "shop", to: "/shop", label: "ซื้อชีท" },
  { match: "seller", to: "/seller", label: "ขายชีท" },
  { match: "about", to: "/faq", label: "ช่วยเหลือ" },
];
const HYTEXT_NOTI_LOCALSTORAGE_KEY = "hytext_noti_read";

const hasEmptyProperties = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key].trim().length === 0) {
      return true;
    }
  }
  return false;
};

class Nav extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      sideopen: false,
      unreadMsg: 0,
      showHytextNoti: false,
      isLoggedin: false,
      isSeller: false,
    };
  }

  async componentDidMount() {
    const data = await Util.sendPost("/api/user/getNumUnreadMessage");
    if (data.success) this.setState({ unreadMsg: data.data.count });

    const dataHytext = await Util.sendPost("/api/public/getHome");
    if (dataHytext.data.user) {
      this.setState({ isLoggedin: true });
      if (dataHytext.data.user.seller) {
        this.setState({ isSeller: true });

        // Force sellers that does not have complete data
        const dataSeller = await Util.sendPost("/api/seller/getSellEdit");
        if (
          window.location.pathname !== "/seller/selledit" &&
          hasEmptyProperties(dataSeller.data.info)
        ) {
          alert("ข้อมูลผู้เขียนไม่ครบถ้วน โปรดอัพเดตก่อนใช้งานระบบต่อ");
          window.location.href = "/seller/selledit";
        }
      }
      if (!localStorage.getItem(HYTEXT_NOTI_LOCALSTORAGE_KEY)) {
        this.setState({ showHytextNoti: true });
      }
    }
  }

  render() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    const lang = Util.getLang();
    const cart = Util.getCart();
    return (
      <React.Fragment>
        {this.props.user && !this.props.user.infoEnter && (
          <Redirect to="/infoEnter" />
        )}
        {this.state.unreadMsg > 0 && !this.props.ale && (
          <Link to="/message">
            <div className={style.unread}>
              คุณมี {this.state.unreadMsg} การแจ้งเตือนใหม่ คลิกเพื่ออ่าน
            </div>
          </Link>
        )}
        {this.state.isLoggedin &&
          currentMonth === 9 &&
          currentYear === 2025 && (
            <div
              className={style.hytextnotireopen}
              onClick={() => {
                this.setState({ showHytextNoti: true });
              }}
            >
              อ่านประกาศสำคัญของเดือนกันยายน พ.ศ. 2568
            </div>
          )}
        {this.state.showHytextNoti && (
          <div className={style.popup}>
            <div className={style.popuphytext}>
              <div className={style.hytextHeader}>ประกาศ</div>
              <div className={style.hytextContent}>
                {this.getHytextTransitionSellerText()}
              </div>
              <div
                className={style.hytextClose}
                onClick={() => {
                  this.setState({ showHytextNoti: false });
                  localStorage.setItem(HYTEXT_NOTI_LOCALSTORAGE_KEY, "true");
                }}
              >
                <span>
                  ฉันได้อ่านและทำความเข้าใจข้อความด้านบนแล้ว
                  และต้องการปิดข้อความนี้
                </span>
              </div>
            </div>
          </div>
        )}
        <Hidden xs sm md>
          <div className={style.navBlock} />
          <Container>
            <div className={style.navContainer}>
              <div className={style.logoNav}>
                <img src={logonav} alt="logonav" />
              </div>
              <div className={style.allright}>
                <div className={style.menuCon}>
                  {menus.map((menu) => {
                    var curr = [style.listLeft];
                    if (this.props.current === menu.match)
                      curr.push(style.active);
                    return (
                      <Link to={menu.to} key={menu.match}>
                        <div className={curr.join(" ")}>{menu.label}</div>
                      </Link>
                    );
                  })}
                </div>
                <div className={style.rightCon}>
                  {this.props.user && (
                    <React.Fragment>
                      <Link to="/message">
                        <img
                          alt="bellPic"
                          src={bellPic}
                          className={style.bell}
                        />
                      </Link>
                      {cart.length > 0 && (
                        <div className={style.cartSize}>{cart.length}</div>
                      )}
                    </React.Fragment>
                  )}
                  <Link to="/cart">
                    <img alt="cartPic" src={cartPic} className={style.cart} />
                    {this.state.unreadMsg > 0 && (
                      <div className={style.cartSize}>
                        {this.state.unreadMsg}
                      </div>
                    )}
                  </Link>
                  {this.props.user ? (
                    <React.Fragment>
                      <div
                        className={style.userPanel}
                        onClick={() => {
                          this.setState({ sideopen: !this.state.sideopen });
                        }}
                      >
                        <img
                          alt=""
                          src={
                            process.env.REACT_APP_USER_PIC +
                            this.props.user._id +
                            ".jpg"
                          }
                          className={style.userPic}
                        />
                      </div>
                      {this.state.sideopen ? (
                        <div className={style.sidePanel}>
                          <Link to="/mysheet">
                            <div className={style.linkage}>ชีทของฉัน</div>
                          </Link>
                          <Link to="/favorite">
                            <div className={style.linkage}>รายการโปรด</div>
                          </Link>
                          <Link to="/message">
                            <div className={style.linkage}>
                              ข้อความแจ้งเตือน
                            </div>
                          </Link>
                          <div className={style.logout} onClick={this.logout}>
                            ออกจากระบบ
                          </div>
                        </div>
                      ) : null}
                    </React.Fragment>
                  ) : (
                    <Link to="/login">
                      <div className={style.loginButton}>เข้าสู่ระบบ</div>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </Container>
        </Hidden>

        <Visible xs sm md>
          {!this.state.open && this.navMobileStuff(cart, true)}
          {this.state.open && (
            <div
              className={
                this.state.open
                  ? [style.navPanelMobile, style.open].join(" ")
                  : style.navPanelMobile
              }
            >
              {this.navMobileStuff(cart, false)}
              <div className={style.navPanelContent}>
                <div className={style.mobileBreak} />
                {menus.map((menu) => {
                  var curr = [
                    style.listMobile,
                    style["listMobileText" + lang.toString()],
                  ];
                  if (this.props.current === menu.match)
                    curr.push(style.active);
                  return (
                    <Link to={menu.to} key={menu.match}>
                      <div className={curr.join(" ")}>{menu.label}</div>
                    </Link>
                  );
                })}
                <div className={style.mobileBreak} />
                {this.props.user ? (
                  <React.Fragment>
                    <img
                      alt=""
                      src={
                        process.env.REACT_APP_USER_PIC +
                        this.props.user._id +
                        ".jpg"
                      }
                      className={style.userPicMobile}
                    />
                    <div className={style.userTextMobile}>
                      {this.props.user.name}
                    </div>
                    <Link to={"/mysheet"}>
                      <div
                        className={[
                          style["listMobileText" + lang.toString()],
                          style.listMobile,
                        ].join(" ")}
                      >
                        ชีทของฉัน
                      </div>
                    </Link>
                    <Link to={"/favorite"}>
                      <div
                        className={[
                          style["listMobileText" + lang.toString()],
                          style.listMobile,
                        ].join(" ")}
                      >
                        รายการโปรด
                      </div>
                    </Link>
                    <Link to={"/message"}>
                      <div
                        className={[
                          style["listMobileText" + lang.toString()],
                          style.listMobile,
                        ].join(" ")}
                      >
                        ข้อความแจ้งเตือน
                      </div>
                    </Link>
                    <div className={style.logoutMobile} onClick={this.logout}>
                      ออกจากระบบ
                    </div>
                  </React.Fragment>
                ) : (
                  <Link to="/login">
                    <div className={style.loginButtonMobile}>เข้าสู่ระบบ</div>
                  </Link>
                )}
              </div>
            </div>
          )}
        </Visible>
      </React.Fragment>
    );
  }

  navMobileStuff = (cart, outer) => {
    return (
      <div
        className={
          style.navContainerMobile +
          (this.state.open && outer ? " " + style.outer : "")
        }
      >
        <div
          className={style.hamContainer}
          onClick={() => {
            this.setState({ open: !this.state.open });
          }}
        >
          <span
            className={
              this.state.open
                ? [style.line1, style.open].join(" ")
                : style.line1
            }
          />
          <span
            className={
              this.state.open
                ? [style.line2, style.open].join(" ")
                : style.line2
            }
          />
          <span
            className={
              this.state.open
                ? [style.line3, style.open].join(" ")
                : style.line3
            }
          />
        </div>
        <img alt="" src={logo} className={style.logoMid} />
        <div className={style.rightMobile}>
          <Link to="/cart">
            <img alt="" src={cartPic} className={style.cartMobile} />
            {cart.length > 0 && (
              <div className={style.cartSizeMobile}>{cart.length}</div>
            )}
          </Link>
          {this.props.user && (
            <img
              alt=""
              src={
                process.env.REACT_APP_USER_PIC + this.props.user._id + ".jpg"
              }
              className={style.userPicNavMobile}
            />
          )}
        </div>
      </div>
    );
  };

  logout = () => {
    localStorage.setItem("auth", "");
    window.location.reload();
  };

  getHytextTransitionSellerText = () => {
    return (
      <React.Fragment>
        <ol>
          <li>
            <u>ขอความร่วมมือนักเขียนทุกท่าน</u>
            <b> </b>
            เข้าไป
            <b>
              <i>อัปเดทข้อมูลนักเขียน</i>
            </b>
            ในระบบให้ครบถ้วนตามที่กำหนด ภายในวันที่<b> 7 กันยายน 2568 </b>
            หากข้อมูลไม่ครบถ้วน อาจมีผลต่อการได้รับเงินยอดขายที่ล่าช้ากว่ากำหนด
            ข้อมูลที่จำเป็นต้องอัปเดทในระบบ ดังนี้{" "}
            <ol>
              <li>ชื่อ นามสกุล ตามบัตรประชาชน (ชื่อผู้ขาย)</li>
              <li>เลขที่บัตรประชาชน</li>
              <li>ที่อยู่ตามบัตรประชาชน และรหัสไปรษณีย์</li>
              <li>เบอร์โทรศัพท์ที่ติดต่อได้ และอีเมลสำหรับแจ้งการโอนเงิน</li>
              <li>
                ชื่อธนาคาร เลขที่บัญชี (ชื่อบัญชีธนาคารจะต้องตรงกับชื่อผู้ขาย)
              </li>
            </ol>
          </li>
          <li>
            <b>
              เรามีความจำเป็นที่จะต้องปรับปรุงระบบบัญชีและการส่งมอบรายได้แบบใหม่อย่างถูกต้อง
              เพื่อการดำเนินงานที่ต่อเนื่องและมั่นคงของผู้ดำเนินการใหม่
              ซึ่งมีรายละเอียดดังนี้
            </b>
            <ol>
              <li>
                การจ่ายค่ายอดขายให้กับนักเขียน ซึ่งจะเปลี่ยนช่วงวันโอนเงิน
                จากไม่เกินวันที่ 7 ของทุกเดือน
                <b>
                  {" "}
                  <u>เป็นจ่ายทุกวันที่ 20 ของทุกเดือน</u>
                </b>
              </li>
              <li>
                นักเขียนจะยังคงได้ยอดขายเต็มจำนวนหลังหักค่าดำเนินการ
                <b>หากใช้บัญชีของธนาคารไทยพาณิชย์เป็นบัญชีผู้รับเงิน</b>
                และหากใช้บัญชีผู้รับเงินของธนาคารอื่นจะมีการหักค่าธรรมเนียมการโอนเงิน
                8 บาท (การหักค่าธรรมเนียมการโอนเงิน จะเริ่มมีผลวันที่ 1
                พฤศจิกายน 2568) โดยกำหนดการโอนเงินยอดขาย ขั้นต่ำ 100 บาท
                หากยอดรายได้ไม่ถึง และต้องการถอนเงินสามารถติดต่อได้โดยตรงที่
                contact@moresheet.co
              </li>
              <li>
                การหัก ณ ที่จ่าย จะเปลี่ยนเป็นระบบ e-Withholding Tax
                ในอัตราเพียง 1% ของรายได้
              </li>
            </ol>
          </li>
        </ol>
        <p>
          <b>การจัดการข้อมูลส่วนบุคคลของท่าน</b>
        </p>
        <p>
          เพื่อให้การบริการเป็นไปอย่างต่อเนื่อง
          ข้อมูลของท่านที่จำเป็นต่อการใช้งานแพลตฟอร์มจะถูกโอนไปยังบริษัท
          ไฮเท็คซ์ อินเตอร์แอคทีฟ จํากัด อย่างปลอดภัย โดยบริษัท ไฮเท็คซ์
          อินเตอร์แอคทีฟ จํากัด จะเข้าเป็นผู้ควบคุมข้อมูลส่วนบุคคลรายใหม่
          และจะดูแลรักษาข้อมูลของท่านภายใต้นโยบายคุ้มครองข้อมูลส่วนบุคคลของบริษัท
          ไฮเท็คซ์ อินเตอร์แอคทีฟ จํากัด ซึ่งท่านสามารถศึกษาได้<b> </b>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={process.env.REACT_APP_PRIVACY_POLICY_URL}
          >
            ที่นี่
          </a>
        </p>
        <p>
          เราขอขอบคุณสำหรับความไว้วางใจและการสนับสนุนของท่านเสมอมา
          หากท่านมีคำถามเพิ่มเติมเกี่ยวกับการเปลี่ยนแปลงครั้งนี้
          สามารถติดต่อเราได้ที่ contact@moresheet.co
          และหากมีคำถามเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคลโดยผู้ดำเนินการใหม่
          สามารถติดต่อบริษัท ไฮเท็คซ์ อินเตอร์แอคทีฟ จํากัด ได้โดยตรงที่
          contact@moresheet.co
        </p>
        <p>ด้วยความเคารพอย่างสูง</p>
        <p>ทีมงานบริษัท More Services</p>
      </React.Fragment>
    );
  };
}

export default Nav;
